/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { FolderPath } from 'cio/components/asset-library';

interface AssetLibraryToolbarFolderNavigationBreadcrumbArgs {
  folderPath: FolderPath;
  isCurrentFolder?: boolean;
  onClick: (folderId: string) => unknown;
  onDrop: (folder: FolderPath) => unknown;
}

export default class AssetLibraryToolbarFolderNavigationBreadcrumb extends Component<AssetLibraryToolbarFolderNavigationBreadcrumbArgs> {}
